import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip, Box } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';

export const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  React.useEffect(() => {
    i18n.changeLanguage('fr');
  }, [i18n]);

  const toggleLanguage = () => {
    const newLang = i18n.language === 'fr' ? 'en' : 'fr';
    i18n.changeLanguage(newLang);
  };

  return (
    <Tooltip
      title={
        i18n.language === 'fr' ? 'Switch to English' : 'Passer en français'
      }
    >
      <IconButton
        color="inherit"
        onClick={toggleLanguage}
        aria-label="toggle language"
        sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
      >
        <LanguageIcon />
        <Box component="span" sx={{ ml: 0.5, fontSize: '0.875rem' }}>
          {i18n.language === 'fr' ? 'FR' : 'EN'}
        </Box>
      </IconButton>
    </Tooltip>
  );
};
